import * as React from 'react';

import styled from '../../theme';
import ProjectTypeNav from '../../components/ProjectTypeNav';
import Header from './Header';
import ImageArea from './ImageArea';
import NewsletterSubscription from './NewsletterSubscription';

const Container = styled.div`
  background-color: #d79454;
  color: #7c4b14;
`;

const MaxWidthInner = styled.div`
  @media (min-width: ${props => props.theme.mobileBreakpoint}px) {
    width: 65%;
  }
  margin: 0 auto;
`;

class BioSection extends React.PureComponent {
  render() {
    return (
      <>
        <Container>
          <ProjectTypeNav />
          <MaxWidthInner>
            <Header />
            <ImageArea />
            <NewsletterSubscription />
          </MaxWidthInner>
        </Container>
      </>
    );
  }
}

export default BioSection;



// WEBPACK FOOTER //
// ./src/scenes/About/BioSection.tsx